import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Header } from './components/site/Header';
import { Wordmark } from './components/site/Wordmark';
import { Threshold } from './components/sections/Threshold';
import { Manifesto } from './components/sections/Manifesto';
import { Currently } from './components/sections/Currently';
import { Practice } from './components/sections/Practice';
import { Resonance } from './components/sections/Resonance';
import { Designer } from './components/sections/Designer';
import { Conversation } from './components/sections/Conversation';
import { Footer } from './components/sections/Footer';
export function App() {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Smooth scrolling handled via CSS scroll-behavior in index.css
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  return <div className="bg-ink min-h-screen text-parchment selection:bg-brass/30 selection:text-white overflow-x-hidden" data-id="element-0">
      {/* Page Load Intro */}
      <AnimatePresence data-id="element-1">
        {isLoading && <motion.div className="fixed inset-0 z-[100] bg-ink flex items-center justify-center" initial={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeInOut'
      }} data-id="element-2">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 1.05
        }} transition={{
          duration: 0.8
        }} data-id="element-3">
              <Wordmark variant="stacked" color="white" data-id="element-4" />
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Main Content */}
      <Header data-id="element-5" />

      <main data-id="element-6">
        <Threshold data-id="element-7" />
        <Manifesto data-id="element-8" />
        <Currently data-id="element-9" />
        <Practice data-id="element-10" />
        <Resonance data-id="element-11" />
        <Designer data-id="element-12" />
        <Conversation data-id="element-13" />
      </main>

      <Footer data-id="element-14" />
    </div>;
}